import { apiClient } from "./apiClient";

export const importApi = {
  // Headers and a guess at which column is which. The guess is offered
  // for correction, never applied -- getting it wrong silently would put
  // addresses in the notes field of four hundred sites.
  inspect: (entity, content) =>
    apiClient.post("/import/inspect", { entity, content }).then((r) => r.data),

  // dryRun defaults to TRUE at both ends. Writing because a caller forgot
  // a flag is the one failure this must not have.
  run: (entity, content, mapping, dryRun = true) =>
    apiClient
      .post("/import/run", { entity, content, mapping, dry_run: dryRun })
      .then((r) => r.data),
};
